import { useState } from "react"
import MyButton from "../../../UI/form/MyButton"
import MyModal from "../../../UI/modal/MyModal"
import QrCodeIcon from '@mui/icons-material/QrCode';
import PackQr from "./PackQr";
import LineWeightIcon from '@mui/icons-material/LineWeight';

const PackQrGet = ({ packId, type }) => {

	const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                type && type === 'barcode' ?
                    <LineWeightIcon />
                :
                    <QrCodeIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={
                type && type === 'barcode' ? 
                    'Отримати Щтрих-коди партії'
                : 
                    'Отримати QR-коди партії'
            }
            disableClickOutside={true}
            content={
                <PackQr
					packId={packId}
                    setOpen={setOpen}
                    type={type}
                />
            }
        />
    </>
  )
}

export default PackQrGet